module.exports = __webpack_public_path__ + "static/media/sport-sante.5fb69ba8.png";